import * as React from "react";
const SvgFiRrTruckMonster = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-truck-monster_svg__a)">
      <path
        fill="#062147"
        d="M23 17h-.1a5 5 0 0 0-.729-1.756l.073-.073a1 1 0 0 0-1.414-1.414l-.073.073A5 5 0 0 0 19 13.1V13a1 1 0 0 0-2 0v.1a5 5 0 0 0-1.756.729l-.073-.073a1 1 0 0 0-1.414 1.414l.073.073A5 5 0 0 0 13.1 17h-2.2a5 5 0 0 0-.729-1.756l.073-.073a1 1 0 0 0-1.414-1.414l-.073.073A5 5 0 0 0 7 13.1V13a1 1 0 1 0-2 0v.1a5 5 0 0 0-1.756.729l-.073-.073a1 1 0 0 0-1.414 1.414l.073.073A5 5 0 0 0 1.1 17H1a1 1 0 0 0 0 2h.1c.127.627.375 1.223.729 1.756l-.073.073a1 1 0 0 0 1.414 1.414l.073-.073c.533.355 1.13.602 1.757.73v.1a1 1 0 1 0 2 0v-.1a5 5 0 0 0 1.756-.729l.073.073a1 1 0 0 0 1.414-1.414l-.073-.073c.355-.533.603-1.13.73-1.757h2.2c.127.627.375 1.223.729 1.756l-.073.073a1 1 0 0 0 1.414 1.414l.073-.073c.533.355 1.13.602 1.757.73v.1a1 1 0 0 0 2 0v-.1a5 5 0 0 0 1.756-.729l.073.073a1 1 0 0 0 1.414-1.414l-.073-.073c.355-.533.602-1.13.73-1.757h.1a1 1 0 1 0 0-2m-5 4a3 3 0 1 1 0-6 3 3 0 0 1 0 6M6 21a3 3 0 1 1 0-6 3 3 0 0 1 0 6m-5-9a1 1 0 0 0 1-1 2 2 0 0 1 2-2h16a2 2 0 0 1 2 2 1 1 0 0 0 2 0 4.006 4.006 0 0 0-3.493-3.968l-4.1-5.148A4.97 4.97 0 0 0 12.5 0H12a3 3 0 0 0-3 3v4H4a4 4 0 0 0-4 4 1 1 0 0 0 1 1m10-9a1 1 0 0 1 1-1h.5a2.98 2.98 0 0 1 2.346 1.13L17.925 7H11z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-truck-monster_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTruckMonster;
